(function(angular){
	'use strict';
	
	angular
		.module('ipoModule')
		.controller('IpoMobileController', [
			'ipoFactory',
			IpoMobileControllerFunction
		]);
	
	function IpoMobileControllerFunction(
		ipoFactory
	){
		var ipo = this;

		ipo.$onInit = function() {
			ipoFactory.getKeyPerformanceIndicators()
				.then(function(keyPerformanceIndicatorsTable) {
					ipo.keyPerformanceIndicatorsTable = keyPerformanceIndicatorsTable;
				});
		};
	}
})(window.angular);